import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { OrdinanceComponent } from './components/ordinance/ordinance.component';
import { PpRulesComponent } from './components/pp-rules/pp-rules.component';
import { RegulationsComponent } from './components/regulations/regulations.component';
import { RouterModule } from '@angular/router';
import { PublicVoilationsComponent } from './components/public-voilations/public-voilations.component';
import { HighlightDirective } from 'src/app/core/directive/highlight.directive';
import { NgxHighlightWordsModule } from 'ngx-highlight-words';
import { LegalCircularsComponent } from './components/legal-circulars/legal-circulars.component';
import { LegalAppealsComponent } from './components/legal-appeals/legal-appeals.component';
import { LegalLitigationComponent } from './components/legal-litigation/legal-litigation.component';



@NgModule({
  declarations: [
    OrdinanceComponent,
    PpRulesComponent,
    RegulationsComponent,
    PublicVoilationsComponent,
    HighlightDirective,
    LegalCircularsComponent,
    LegalAppealsComponent,
    LegalLitigationComponent
  ],
  imports: [
    RouterModule.forChild([
      {
        path: 'documents/ordinance',
        component: OrdinanceComponent,
      },
      {
        path: 'documents/pp-rules',
        component: PpRulesComponent,
      },
      {
        path: 'documents/regulations',
        component: RegulationsComponent,
      },
      {
        path: 'documents/publicvoilations',
        component: PublicVoilationsComponent,
      },
      {
        path: 'documents/legal-circulars',
        component: LegalCircularsComponent,
      },
      {
        path: 'documents/legal-appeals',
        component: LegalAppealsComponent,
      },
      {
        path: 'documents/legal-litigation',
        component: LegalLitigationComponent,
      },

    ]),
    CommonModule,
    FormsModule,
    [NgxHighlightWordsModule]
  ]
})
export class DocumentsModule { }
